import React, { Component } from 'react';
import './TextWithEllipsis.css';

class TextWithEllipsis extends Component {
  constructor(props) {
    super(props);
    this.textRef = React.createRef();
  }

  componentDidMount() {
    const element = this.textRef.current;
    if (element) {
      element.addEventListener('mouseover', this.handleMouseOver);
    }
  }

  componentWillUnmount() {
    const element = this.textRef.current;
    if (element) {
      element.removeEventListener('mouseover', this.handleMouseOver);
    }
  }

  handleMouseOver = (event) => {
    const target = event.currentTarget;
    if (target.offsetWidth < target.scrollWidth && !target.getAttribute('title')) {
      target.setAttribute('title', target.textContent);
    } else if (target.offsetWidth >= target.scrollWidth) {
      target.removeAttribute('title');
    }
  };

  render() {
    const {
      className, text, as: Tag = 'div', onClick
    } = this.props;

    return (
      <Tag ref={this.textRef} className={`text_ellipsis ${className}`} onClick={onClick}>
        {text}
      </Tag>
    );
  }
}

export default TextWithEllipsis;
